// extracted by mini-css-extract-plugin
export default {"leftContainer":"AgreementPage_leftContainer__o+W5P","rightContainer":"AgreementPage_rightContainer__+f295"};